<form *ngIf="jobFormGroup" [formGroup]="jobFormGroup">

    <p-messages *ngIf="workerEconomicNotes" severity="error" [closable]="false" >
        <ng-template pTemplate>
            <div  [innerHtml]="workerEconomicNotes" ></div>
        </ng-template>
    </p-messages>
    <div class="grid">
        <div class="col-4 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" formControlName="date" (onSelect)="loadRateLines()" [showIcon]="true"
                [showButtonBar]="true" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy"
                appendTo="body" [readonlyInput]="true" d-form-field-error [disabled]="true"></p-calendar>
        </div>
        <div class="col-8 input-field">
            <label for="capabilityId">Especialidad</label>
            <p-dropdown [(ngModel)]="selectedCapability" [ngModelOptions]="{standalone:true}" [options]="capabilities"
                (onChange)="selectCapability($event)" optionLabel="name" optionValue="id" [filter]="true"
                filterBy="name" appendTo="body" placeholder="Selecciona una especialidad" d-form-field-error
                [disabled]="(job.transactionId != null || jobFormGroup.controls['isBillable'].value) && job.id?true:false"></p-dropdown>
        </div>
        <!--<div class="col-12 input-field" *ngIf="rates.length>1">
            <label for="rateLineId">Baremo</label>
            <p-dropdown [(ngModel)]="selectedRateId" [ngModelOptions]="{standalone:true}" [options]="rates" optionValue="id" optionLabel="name"
                (onChange)="selectRate($event)" appendTo="body" placeholder="Selecciona un baremo" [disabled]="(job.transactionId != null || jobFormGroup.controls['isBillable'].value) && job.id?true:false" d-form-field-error>                
            </p-dropdown>
            <small class="text-danger">Atención! Se han detectado varios baremos disponibles, selecciona el adecuado.</small>
        </div>-->
        <div class="col-8 input-field" [class.col-12]="jobType != 'COMPANY'">
            <label for="rateLineId">Baremo</label>
            <p-dropdown formControlName="rateLineId" [options]="rateLines" optionValue="id" optionLabel="displayName"
                appendTo="body" placeholder="Selecciona un código" (onChange)="onRateLineChange($event)"
                showClear [filter]="true" d-form-field-error>
                <ng-template let-rateLine pTemplate="item">
                    <div class="flex flex-column">
                        <div style="white-space: normal;max-width: 700px;">{{ rateLine.displayName }}</div>
                        <small style="font-size: 8px;">{{ getRate(rateLine.rateId)?.name }}</small>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-4 input-field" *ngIf="jobType == 'COMPANY'">
            <label for="target">Destinatario</label>
            <p-dropdown formControlName="target" [options]="targets" optionValue="id" optionLabel="name" appendTo="body"
                placeholder="Selecciona un destinatario" showClear [filter]="true" d-form-field-error
                (onChange)="onTargetChange($event)"
                [disabled]="(job.transactionId != null || jobFormGroup.controls['isBillable'].value) && job.id">
            </p-dropdown>
        </div>

        <!--<div class="col-4 input-field" *ngIf="jobType == 'COMPANY' && jobFormGroup.controls['target'].value == 'ThirdParty'">
            <label for="target">Implicado</label>
            <p-dropdown formControlName="affecteds" [options]="affecteds" optionValue="id" optionLabel="name" appendTo="body"
                placeholder="Selecciona un implicado" showClear [filter]="true" d-form-field-error
                (onChange)="onTargetChange($event)"
                [disabled]="(job.transactionId != null || jobFormGroup.controls['isBillable'].value) && job.id">
            </p-dropdown>
        </div>-->

        <div class="col-12 input-field">
            <label for="description">Descripción</label>
            <textarea formControlName="description" pInputTextarea rows="5" d-form-field-error></textarea>
        </div>
        <div [ngClass]="getFieldColClass()" class="input-field">
            <label for="quantity">Cantidad</label>
            <input formControlName="quantity" pInputText type="number" d-form-field-error (input)="calculatePrices()">
        </div>

        <!-- Precio -->
        <div [ngClass]="getFieldColClass()" class="input-field">
            <label for="unitPrice">Precio</label>
            <input formControlName="unitPrice" pInputText type="number" d-form-field-error (input)="calculatePrices()">
        </div>

        <!-- Descuento -->
        <div *ngIf="jobType === 'COMPANY'" [ngClass]="getFieldColClass()" class="input-field">
            <label for="jobCompanyDiscountPercent">Descuento compañía (%)</label>
            <input formControlName="jobCompanyDiscountPercent" pInputText type="number" d-form-field-error
                (input)="calculatePrices()">
            <label class="mt-2">
                {{ jobCompanyDiscountAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>

        <!-- Impuestos -->
        <div [ngClass]="getFieldColClass()" class="input-field">
            <label for="code">Impuestos (%)</label>
            <p-dropdown formControlName="taxPercent" [options]="taxes" optionLabel="displayName" optionValue="percent"
                appendTo="body" filterBy="name" placeholder="Seleccione opción" (onChange)="calculatePrices()"
                d-form-field-error>
            </p-dropdown>
            <label class="mt-2">
                {{ jobFormGroup.get('taxAmount')?.value | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>

        <!-- Incremento guardia -->
        <div *ngIf="jobType === 'COMPANY' && isGuard" [ngClass]="getFieldColClass()" class="input-field">
            <label for="jobGuardCompanyIncrementPercent">Incremento guardia (%)</label>
            <input formControlName="jobGuardCompanyIncrementPercent" pInputText type="number" d-form-field-error
                (input)="calculatePrices()" />
            <label class="mt-2">
                {{ jobGuardCompanyIncrementAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>

        <!-- Total -->
        <div [ngClass]="getFieldColClass()" class="input-field">
            <label class="mb-3" for="total">Total</label>
            <span class="mt-2">
                {{ jobFormGroup.get('total')?.value | currency:'EUR':'symbol':'1.2-2' }}
            </span>
        </div>
        <div class="col-3 input-field">
            <label for="isReview">Revisado</label>
            <p-inputSwitch formControlName="isReview" d-form-field-error></p-inputSwitch>
        </div>
        <div class="col-3 input-field">
            <label for="isBillable">Es facturable</label>
            <p-inputSwitch formControlName="isBillable" d-form-field-error  [disabled]="!jobFormGroup.controls['isReview'].value"
                (onChange)="toggleFormState()"></p-inputSwitch>
        </div>
        <div class="col-3 input-field" *ngIf="jobType == 'COMPANY'">
            <label for="chargedByWorker">Cobrado por operario</label>
            <p-inputSwitch formControlName="chargedByWorker" d-form-field-error
                (onChange)="toggleFormState()"></p-inputSwitch>
        </div>
        <!-- Check si estamos hablando de proveedor con valor que es cobrado a la compañía -->
        <!--<div class="col-3 input-field" *ngIf="jobType == 'COMPANY' && providerId!=null">
            <label for="showCasesServices">No procede contabilizarlo aqui {{showCasesServices}}</label>
            <p-inputSwitch (onChange)="toggleNoProcede($event)"></p-inputSwitch>
        </div>
        <div class="col-12" *ngIf="showCasesServices">
            <p-message severity="info" text="Este trabajo no se contabilizará aquí, por favor, seleccione el servicio al que se va a asociar este trabajo"></p-message>
            <label for="jobRelatedId">Trabajo relacionado</label>
            <p-dropdown formControlName="jobRelatedId" [options]="jobs" optionLabel="label" optionValue="id"
                appendTo="body" [filter]="true" filterBy="label" showClear placeholder="Selecciona una visita"
                d-form-field-error></p-dropdown>
        </div>-->
    </div>
    <div class=" mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar"
            *ngIf="allowDelete && ((job.transactionId == null && job.workerBillableItemLineId == null) || allowDeleteAll) && job.id != '' && !jobFormGroup.controls['isBillable'].value"
            icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite && job.transactionId == null && job.workerBillableItemLineId == null" icon="pi pi-check" styleClass="p-ml-2"
            (click)="preSave()"></p-button>
    </div>
</form>
<p-confirmDialog></p-confirmDialog>